import React from "react";
import moment from "moment";
import IntlMessages from "../../helpers/IntlMessages";

export class FastCheckinPrint extends React.PureComponent {
  attachment = passport => {
    const fileName = passport.split("/").pop();
    const extension = fileName.split(".").pop();
    if (extension === "png" || extension === "jpeg" || extension === "jpg") {
      return <img src={passport} alt="passport attachment" className="preview-container" />;
    }
    return (
      <div>
        <i className="simple-icon-paper-clip" /> <i>{fileName}</i>
      </div>
    );
  };

  render() {
    return (
      <div className="container print-page" ref={this.props.ref}>
        <div className="text-center  mb-5 ">
          <h1 className="print-header">
            <IntlMessages id="booking.guest_information_form" />
          </h1>
        </div>
        <div className="print-content ">
          <div className="d-flex ">
            <p className="bolder-text">
              <IntlMessages id="booking.full_name" />:
            </p>
            <p className="user-info">
              {this.props.personelInfo.name} {this.props.personelInfo.surname}
            </p>
          </div>
          {this.props.personelInfo.father_name != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                {" "}
                <IntlMessages id="booking.father_name" />:
              </p>
              <p className="user-info">{this.props.personelInfo.father_name}</p>
            </div>
          )}
          {this.props.personelInfo.mother_name != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.mother_name" />:
              </p>
              <p className="user-info">{this.props.personelInfo.mother_name}</p>
            </div>
          )}
          {this.props.personelInfo.national_identification_number && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="bookingDetails.national_identification_number" />:
              </p>
              <p className="user-info">{this.props.personelInfo.national_identification_number}</p>
            </div>
          )}
          {this.props.personelInfo.birth_date != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="bookingDetails.birth_date" />:
              </p>
              <p className="user-info">{moment(this.props.personelInfo.birth_date * 1000).format("DD-MM-YYYY")}</p>
            </div>
          )}
          {this.props.personelInfo.nationality != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="bookingDetails.nationality" />:
              </p>
              <p className="user-info">{this.props.personelInfo.nationality}</p>
            </div>
          )}
          {this.props.personelInfo.passport_number && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="bookingDetails.passport_number" />:
              </p>
              <p className="user-info">{this.props.personelInfo.passport_number}</p>
            </div>
          )}
          {this.props.personelInfo.birth_place != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.birth_place" />:
              </p>
              <p className="user-info">{this.props.personelInfo.birth_place}</p>
            </div>
          )}
          {this.props.personelInfo.gender != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="bookingDetails.gender" />:
              </p>
              <p className="user-info">{this.props.personelInfo.gender}</p>
            </div>
          )}
          {this.props.personelInfo.document_type != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.document_type" />:
              </p>
              <p className="user-info">{this.props.personelInfo.document_type}</p>
            </div>
          )}
          {this.props.personelInfo.serial_number != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.serial_number" />:
              </p>
              <p className="user-info">{this.props.personelInfo.serial_number}</p>
            </div>
          )}
          {this.props.personelInfo.city_of_registry != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.city_of_registry" />:
              </p>
              <p className="user-info">{this.props.personelInfo.city_of_registry}</p>
            </div>
          )}

          {this.props.personelInfo.town_of_registry && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.town_of_registry" />:
              </p>
              <p className="user-info">{this.props.personelInfo.town_of_registry}</p>
            </div>
          )}
          {this.props.personelInfo.date_of_issue != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.date_of_issue" />:
              </p>
              <p className="user-info">{this.props.personelInfo.date_of_issue}</p>
            </div>
          )}
          {this.props.personelInfo.date_of_expire != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.date_of_expire" />:
              </p>
              <p className="user-info">{this.props.personelInfo.date_of_expire}</p>
            </div>
          )}
          {this.props.personelInfo.address != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.address" />:
              </p>
              <p className="user-info">{this.props.personelInfo.address}</p>
            </div>
          )}
          {this.props.personelInfo.city != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.city" />:
              </p>
              <p className="user-info">{this.props.personelInfo.city}</p>
            </div>
          )}
          {this.props.personelInfo.country != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.country" />:
              </p>
              <p className="user-info">{this.props.personelInfo.country}</p>
            </div>
          )}
          {this.props.personelInfo.checkin != null && this.props.personelInfo.checkout != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="bookingDetails.checkin_checkout" />:
              </p>
              <p className="user-info">
                {moment(this.props.personelInfo.checkin * 1000).format("DD-MM-YYYY")}/
                {moment(this.props.personelInfo.checkout * 1000).format("DD-MM-YYYY")}
              </p>
            </div>
          )}
          {this.props.personelInfo.time_of_arrival != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.time_of_arrival_at_hotel" />:
              </p>
              <p className="user-info">{moment(this.props.personelInfo.time_of_arrival * 1000).format("DD-MM-YYYY")}</p>
            </div>
          )}

          {this.props.personelInfo.car_plate != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.car_plate" />:
              </p>
              <p className="user-info">{this.props.personelInfo.car_plate}</p>
            </div>
          )}
          {this.props.personelInfo.phone_number != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.phone-placeholder" />:
              </p>
              <p className="user-info">{this.props.personelInfo.phone_number}</p>
            </div>
          )}
          {this.props.personelInfo.email != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="user.email" />:
              </p>
              <p className="user-info">{this.props.personelInfo.email}</p>
            </div>
          )}
          {this.props.personelInfo.has_pet != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.has_pet" />:
              </p>
              <p className="user-info">{this.props.personelInfo.has_pet}</p>
            </div>
          )}
          {this.props.personelInfo.note != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="user.note" />:
              </p>
              <p className="user-info">{this.props.personelInfo.note}</p>
            </div>
          )}
          {this.props.personelInfo.all_number != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="user.all_number" />:
              </p>
              <p className="user-info">{this.props.personelInfo.all_number}</p>
            </div>
          )}
          {this.props.personelInfo.billing_address != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.billing_address" />:
              </p>
              <p className="user-info">{this.props.personelInfo.billing_address}</p>
            </div>
          )}
          {this.props.personelInfo.hescode != null && (
            <div className="d-flex  mb-5 pb-5">
              <p className="bolder-text">
                <IntlMessages id="booking.hescode" />:
              </p>
              <p className="user-info">{this.props.personelInfo.hescode}</p>
            </div>
          )}
          {this.props.personelInfo.TM6Form_number != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.TM6Form_number" />:
              </p>
              <p className="user-info">{this.props.personelInfo.TM6Form_number}</p>
            </div>
          )}
          {this.props.personelInfo.has_traveled === true && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.has_traveled" />
              </p>
              <p className="user-info">{this.props.personelInfo.has_traveled}</p>
            </div>
          )}
          {this.props.personelInfo.dietary_requirements != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.dietary_requirements" />:
              </p>
              <p className="user-info">{this.props.personelInfo.dietary_requirements}</p>
            </div>
          )}
          {this.props.personelInfo.postal_code != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.postal_code" />:
              </p>
              <p className="user-info">{this.props.personelInfo.postal_code}</p>
            </div>
          )}
          {this.props.personelInfo.arrival_flight != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.arrival_flight" />:
              </p>
              <p className="user-info">{this.props.personelInfo.arrival_flight}</p>
            </div>
          )}
          {this.props.personelInfo.departure_flight != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.departure_flight" />:
              </p>
              <p className="user-info">{this.props.personelInfo.departure_flight}</p>
            </div>
          )}
          {this.props.personelInfo.visa_type != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.visa_type" />:
              </p>
              <p className="user-info">{this.props.personelInfo.visa_type}</p>
            </div>
          )}
          {this.props.personelInfo.visa_expiry_date != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.visa_expiry_date" />:
              </p>
              <p className="user-info">{moment(this.props.personelInfo.visa_expiry_date * 1000).format("DD-MM-YYYY")}</p>
            </div>
          )}
          {this.props.personelInfo.passport_front != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.passport_front" />:
              </p>
              <p className="user-info">
                {" "}
                <a href={this.props.personelInfo.passport_front} target="top">
                  {this.attachment(this.props.personelInfo.passport_front)}
                </a>
              </p>
            </div>
          )}
          {this.props.personelInfo.passport_back != null && (
            <div className="d-flex ">
              <p className="bolder-text">
                <IntlMessages id="booking.passport_back" />:
              </p>
              <p className="user-info">
                {" "}
                <a href={this.props.personelInfo.passport_back} target="top">
                  {this.attachment(this.props.personelInfo.passport_back)}
                </a>
              </p>
            </div>
          )}
          <div className="d-flex ">
            <p className="bolder-text">
              <IntlMessages id="booking.date" />:
            </p>
            <p className="user-info">{moment().format("DD-MM-YYYY")}</p>
          </div>
          <div className="d-flex ">
            <p className="bolder-text">
              <IntlMessages id="booking.signature" />:
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default FastCheckinPrint;
